import { t } from '../../../lib/i18n';
import { type BidStatus } from '../types';
import { BID_STATUS_CHIP, BID_STATUS_D_LABEL_KEYS, cn } from '../utils';

/**
 * Bid auction-status chip — `Redesign-D-Admin`, screen «Ставки».
 *
 * The artboard draws every status as a mono, upper-case, letter-spaced chip
 * rather than a rounded pill: on a dense operator table the chip has to read as
 * a *value*, in the same typeface as the amounts beside it, not as a label.
 */
export function BidStatusBadge({ status, className }: { status: BidStatus; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex w-fit items-center rounded-cf-sm px-[7px] py-[3px] font-mono text-[9px] tracking-[0.08em] whitespace-nowrap uppercase lg:px-2 lg:py-1 lg:text-[10px]',
        BID_STATUS_CHIP[status] ?? 'bg-cf-fill text-cf-ink-subtle',
        className,
      )}
    >
      {t(BID_STATUS_D_LABEL_KEYS[status] ?? 'bids.d.state.underReview')}
    </span>
  );
}
